import { CourseProgressClient } from "@/components/admin/course-progress/CourseProgressClient";
import { useParams } from "react-router-dom";

export default function CourseProgressPage() {
    const { id } = useParams<{ id: string }>();
    return <CourseProgressClient courseUuid={id || ""} />;
}
